import { render, staticRenderFns } from "./NominateMemberList.vue?vue&type=template&id=637a7f42"
import script from "./NominateMemberList.vue?vue&type=script&lang=js"
export * from "./NominateMemberList.vue?vue&type=script&lang=js"
import style0 from "./NominateMemberList.vue?vue&type=style&index=0&id=637a7f42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports